import React from "react";
import "./GetMusicOnLenovo.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnLenovo = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload your music release",
    "Select Lenovo Music Distribution",
    "Content delivered to Lenovo ecosystem",
    "Reach millions of device users",
    "Track streams & earnings"
  ];

  return (
    <>
      <Helmet>
        <title>Lenovo Music Distribution | FT Tunes</title>

        <meta
          name="description"
          content="Distribute your music to Lenovo devices worldwide with FT Tunes and reach millions of listeners across smart ecosystems."
        />

        <meta
          name="keywords"
          content="Lenovo music distribution, Lenovo devices music, music distribution service"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="lenovo-page">

        {/* HERO */}
        <section className="lenovo-hero">
          <Container>

            <img
              src="/Images/lenovo-logo.png"
              alt="Lenovo"
              className="lenovo-logo"
            />

            <h1>Distribute Your Music on Lenovo Devices</h1>

            <p>
              Expand your audience by delivering your music across Lenovo’s
              global ecosystem of laptops, tablets, and smart entertainment devices.
            </p>

            <Button
              className="gradient-btn-lenovo"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Distribution
            </Button>

          </Container>

          <div className="hero-glow-lenovo"></div>
        </section>


        {/* SHOWCASE */}
        <section className="lenovo-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Reach Listeners Through Lenovo Ecosystem</h2>

                <p>
                  Lenovo devices power entertainment experiences worldwide.
                  Deliver your music directly to users across smart devices
                  and connected platforms.
                </p>

                <Button
                  className="outline-btn-lenovo"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Upload Music
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-lenovo.png"
                  alt="Lenovo Distribution"
                  className="lenovo-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="lenovo-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card-lenovo">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="lenovo-benefits">
          <Container>

            <h2 className="section-title">
              Why Distribute on Lenovo
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card-lenovo">
                  <h5>Global Device Reach</h5>
                  <p>Millions of Lenovo users worldwide.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-lenovo">
                  <h5>Smart Ecosystem</h5>
                  <p>Connected entertainment platforms.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-lenovo">
                  <h5>High Quality Delivery</h5>
                  <p>Optimized playback across devices.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-lenovo">
                  <h5>Revenue Tracking</h5>
                  <p>Monitor performance & earnings.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="lenovo-cta">
          <Container>

            <h2>Start Your Lenovo Music Distribution Today</h2>

            <Button
              className="gradient-btn-lenovo big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Distribute Now
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnLenovo;